module.exports = __webpack_public_path__ + "img/3_2_m.3e377d75.jpg";